import React, { lazy, Suspense } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import compose from 'recompose/compose';

import Loader from './components/Loader';
import CommunityPage from './containers/Community';
import ErrorPage from './containers/ErrorPage';
import LoginPage from './containers/LoginPage';
import ForgotPassword from './containers/ForgotPassword';
import NewPassword from './containers/NewPassword';
import EditInstitutionPage from './containers/EditInstitution';
import SearchResultsPage from './containers/SearchResultsPage';
import {
  authorizedOrLogin,
  authorizedWithAdminRole,
  notAuthorized,
  requireCommunityProfile,
} from './containers/Authorization';
import RepVisitsUnauthorizedPage from './containers/RepVisitsUnauthorizedPage';
import IntersectSettingsPage from './containers/IntersectSettingsPage';
import { isMockingNavianceLogin } from './utils';
import SubscriptionsPage from './containers/SubscriptionsPage';
import CounselorCommunityServerless from './containers/CounselorCommunityMicro';
import { onFeatureEnabled } from './utils/features';
import { COMMUNITY_SERVERLESS } from './containers/Authorization/constants';

export default (
  <Suspense fallback={<Loader active />}>
    <Switch>
      <Route
        exact
        path="/"
        component={authorizedOrLogin(SubscriptionsPage)}
      />
      <Route
        path="/community/"
        component={authorizedOrLogin(CommunityPage)}
      />
      <Route
        name="counselor-community-profile-serverless"
        path="/counselorcommunity/*"
        component={compose(
          authorizedOrLogin,
          onFeatureEnabled(COMMUNITY_SERVERLESS),
        )(CounselorCommunityServerless)}
      />
      <Route path="/error" component={ErrorPage} />
      <Route path="/login" component={notAuthorized(LoginPage)} />
      <Route path="/new-password" component={notAuthorized(NewPassword)} />
      <Route path="/forgot-password" component={notAuthorized(ForgotPassword)} />
      <Route path="/logout" component={notAuthorized(LoginPage)} />
      <Route
        path="/institution/edit"
        component={compose(
          authorizedOrLogin,
          authorizedWithAdminRole(),
        )(EditInstitutionPage)}
      />
      <Route
        path="/naviance-college-profile/view/:collegeId"
        component={authorizedOrLogin(lazy(() => import('./containers/CollegeProfileEmbedded/viewReact')))}
      />
      <Route
        path="/naviance-college-profile/viewprofile/:scid"
        component={authorizedOrLogin(lazy(() => import('./containers/CollegeProfileEmbedded/viewReact')))}
      />
      <Route
        path="/naviance-college-profile/view-newprofile/:hiid"
        component={authorizedOrLogin(lazy(() => import('./containers/CollegeProfileEmbedded/viewReact')))}
      />
      <Route
        path="/settings"
        component={authorizedOrLogin(IntersectSettingsPage)}
      />
      <Route
        path="/rep-visits"
        component={compose(
          authorizedOrLogin,
          authorizedWithAdminRole({ failure: RepVisitsUnauthorizedPage }),
          requireCommunityProfile,
        )(lazy(() => import('./containers/RepVisitsPageFrame')))}
      />
      <Route
        exact
        path="/search-results/:view"
        component={authorizedOrLogin(SearchResultsPage)}
      />
      {process.env.GRAPHIQL && (
        <Route
          exact
          path="/graphiql"
          component={authorizedOrLogin(lazy(() => import('./containers/GraphQL')))}
        />
      )}
      {isMockingNavianceLogin() && (
        <Route exact path="/mock-naviance-login" component={lazy(() => import('./containers/MockNavianceLoginPage'))} />
      )}
      <Redirect from="*" to="/" />
    </Switch>
  </Suspense>
);
